import React from "react";
import FileDrop from "../../components/fileDrop";
import OptimizedComponent from "../../components/optimizedComponent";
import { stateService } from "../../services/imports";
import { stateEvents } from "../../models/imports";

import {
  createValidationContext,
  Input,
  LoadingButton,
  FieldValidation
} from "../../components/formcontrols/imports";
import {
  translateService,
  authService
} from "../../services/imports";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

import mediaService from "../../services/mediaService";

// Landing page: free document validation (left) and the Keycloak entry
// points (right). Credentials never touch the SPA: every button starts the
// OpenID Connect redirect flow (see docs/RUNBOOK-keycloak-login.md).
export default class LoginPage extends OptimizedComponent {
  constructor(props) {
    super(props);
    this.state = this.initialState();

    this.docValidation = createValidationContext();
  }

  initialState = () => {
    return {
      doc: {
        userName: "",
        doc: null
      },
      isLoginLoading: false,
      isValidationLoading: false,
      errorModal: false,
      success: false,
      errorMessage: "",
      required: false
    };
  };

  defaultState = () => {
    this.setState(this.initialState());
    this.docValidation.removeCustomErrors().setPristine();
  };

  // options: { register: true } | { idpHint: "google" | "facebook" } | { realm: "corp" }
  startLogin = (options) => {
    if (this.state.isLoginLoading) return;
    this.setState({ isLoginLoading: true });

    // where PrivateRoute sent us from, if anywhere
    const returnTo = this.props.location?.state?.from;

    authService.login({ returnTo, ...options }).catch(() => {
      this.setState({
        isLoginLoading: false,
        errorModal: true,
        errorMessage: translateService.t("signing.loginFailed")
      });
    });
  };

  validateDocument = () => {
    if (!this.state.doc.doc) this.setState({ required: true });
    let valid = this.docValidation
      .removeCustomErrors()
      .setDirty()
      .isValid();
    if (!valid || !this.state.doc.doc) {
      stateService.event(stateEvents.validateCheck, { check: true });
      return;
    }
    this.setState({ isValidationLoading: true });

    mediaService
      .uploadFile(
        this.state.doc.doc,
        this.state.doc.userName
      )
      .subscribe(res => {
        if (res?.success) {
          this.setState(prevState => {
            let state = { ...prevState };
            state.isValidationLoading = false;
            state.success = true;
            state.doc.doc = null;
            return { ...state, state };
          });
        }
      }, () => {
        this.setState({ isValidationLoading: false })
      });
  };

  emptyFile = (e) => {
    e.stopPropagation();
    this.setStateProperty({ "doc.userName": "", "doc.doc": null });
  }

  updateErrorInfo = e => {
    !e.target.value && e.target.classList.add("tooltip-error");
  };

  fileDrop = file => {
    this.setState(state => {
      let temp = { ...state };
      if (file) {
        temp.doc.doc = file[0];
        temp.required = false;
      }
      return temp;
    });
  };

  render() {
    const loading = this.state.isLoginLoading;

    return (
      <React.Fragment>
        <div className="item-left">
          <div className="form">
            <span className="title">
              {translateService.t("signing.freevalidationtitle")}
            </span>
            <div className="inputs">
              <div className="input-item">

                <FileDrop
                        className="fileDrops"
                        accept="application/pdf"
                        maxSize={globalConfig.MaxFileSize}
                        required={this.state.required}
                        onDrop={this.fileDrop}
                    >
                    <div className={`upload ${this.state.doc.doc ? 'close':''}`} >
                    <Input
                        type="text"
                        placeholder={translateService.t("common.uploadPdfFile")}
                        spellCheck="false"
                        value={this.state.doc.doc?.name || ""}
                        readOnly
                    />
                    {this.state.doc.doc && <button className="emtyLink" onClick={e => this.emptyFile(e)}></button>}
                    </div>
                </FileDrop>
              </div>

              <div className="input-item">
                <Input
                  name="email"
                  type="email"
                  placeholder={translateService.t("signing.emailPlaceholder")}
                  autoComplete="off"
                  spellCheck="false"
                  maxLength="50"
                  value={this.state.doc.userName || ""}
                  onChange={e => {
                    this.setStateProperty({ "doc.userName": e.target.value });
                  }}
                  rules={[{ name: "email", convert: { trim: true } }]}
                  validation={this.docValidation}
                  ref={input => (this.doc_email = input)}
                  onFocus={e => this.updateErrorInfo(e)}
                />

                <FieldValidation
                  name="email"
                  className="validation-register"
                  rule="email"
                  validation={this.docValidation}
                  for={this.doc_email}
                />
              </div>
            </div>
            <div className="buttons">
              <LoadingButton
                className="button background-color-two color-white"
                loading={this.state.isValidationLoading}
                onClick={this.validateDocument}
              >
                {translateService.t("common.validation")}
              </LoadingButton>
            </div>
          </div>
        </div>
        <div className="item-right">
          <div className="form">
            <span className="title">
              {translateService.t("signing.loginTitle")}
            </span>
            <div className="buttons login-buttons">
              <LoadingButton type="button"
                className="button background-color-two color-white"
                loading={loading}
                onClick={() => this.startLogin({})}
              >
                {translateService.t("signing.login")}
              </LoadingButton>

              <LoadingButton type="button"
                className="button background-color-one color-white"
                disabled={loading}
                onClick={() => this.startLogin({ register: true })}
              >
                {translateService.t("signing.register")}
              </LoadingButton>

              {(globalConfig.oidc_social_enabled || globalConfig.oidc_corp_enabled) && (
                <div className="divider">{translateService.t("signing.or")}</div>
              )}

              {/* hidden until the identity providers are configured (KC2) */}
              {globalConfig.oidc_social_enabled && (
                <LoadingButton type="button"
                  className="button background-color-two color-white"
                  disabled={loading}
                  onClick={() => this.startLogin({ idpHint: "google" })}
                >
                  {translateService.t("signing.continueWithGoogle")}
                </LoadingButton>
              )}

              {globalConfig.oidc_social_enabled && (
                <LoadingButton type="button"
                  className="button background-color-two color-white"
                  disabled={loading}
                  onClick={() => this.startLogin({ idpHint: "facebook" })}
                >
                  {translateService.t("signing.continueWithFacebook")}
                </LoadingButton>
              )}

              {globalConfig.oidc_corp_enabled && (
                <LoadingButton type="button"
                  className="button background-color-three color-white"
                  disabled={loading}
                  onClick={() => this.startLogin({ realm: "corp" })}
                >
                  {translateService.t("signing.corporateLogin")}
                </LoadingButton>
              )}
            </div>
          </div>
        </div>

        <Modal
          isOpen={this.state.errorModal || this.state.errorMessage.length > 0}
          fade={false}
          toggle={e => {
            this.setState({ errorModal: false, errorMessage: "" });
          }}
        >
          <ModalHeader>
            <span>
              &nbsp;
              <span
                onClick={() => this.setState({ errorModal: false, errorMessage: "" })}
                className="clickable"
              >
                <img src="../../assets/images/close32.svg" />
              </span>
            </span>
          </ModalHeader>
          <ModalBody>
            <div className="additional color-three">
              <img src="../../assets/images/modal-error.svg" />
              <div className="title">
                {this.state.errorMessage || translateService.t("common.requestError")}
              </div>
            </div>
          </ModalBody>
          <ModalFooter>

            <LoadingButton type="button"
              className="button background-color-three color-white"
              onClick={() => this.setState({ errorModal: false, errorMessage: "" })}
            >
              {translateService.t(`common.ok`)}
            </LoadingButton>

          </ModalFooter>
        </Modal>

        <Modal
          isOpen={this.state.success}
          fade={true}
          className="modal"
          modalClassName="Modal-dialog"
          backdropClassName="backDrop"
          toggle={e => {
            this.setState({ success: false });
          }}
        >
          <ModalHeader>
            <span>
              &nbsp;
              <span
                onClick={() => this.setState({ success: false })}
                className="clickable"
              >
                <img src="../../assets/images/close32.svg" />
              </span>
            </span>
          </ModalHeader>
          <ModalBody>
            <div className="additional color-black">
              <img src="../../assets/images/modal-success.svg" onClick={() => this.setState({ success: false })} />
              <div className="title">
                {translateService.t('common.succesRequestGoEmail')}
              </div>
            </div>
          </ModalBody>
          <ModalFooter>

            <LoadingButton type="button"
              className="button background-color-two color-white"
              onClick={() => this.setState({ success: false })}
            >
              {translateService.t(`common.ok`)}
            </LoadingButton>

          </ModalFooter>
        </Modal>
      </React.Fragment>
    );
  }
}
